import { Profile } from '../modules/user/types';

/**
 * Returns a meaningful display label for the user's role.
 * Prefers the custom mapped role_name from the backend.
 * Falls back to a human-readable label derived from user_type.
 */
export const getUserRoleLabel = (data: Profile | null): string => {
  if (!data) return '';

  if (data.role_name) return data.role_name;

  switch (data.user_type) {
    case 'super_admin':
      return 'Super Admin';
    case 'org_admin':
      return 'Organization Admin';
    case 'organization_staff':
      return 'Staff Member';
    case 'facility':
      return 'Facility Manager';
    case 'worker':
      return 'Worker';
    default:
      return 'User';
  }
};
